import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import { PORTAL_URL } from '../config'
import BrandMark from './BrandMark'
import StoreBadges from './StoreBadges'

const Footer: React.FC = () => {
  const { t } = useLocale()
  const { pathname } = useLocation()
  const section = (id: string) => (pathname === '/' ? `#${id}` : `/#${id}`)

  return (
    <footer className="bg-surface-inverse px-5 py-14 text-sm text-neutral-400 sm:px-8 lg:px-14">
      <div className="mx-auto grid max-w-[1280px] gap-10 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr]">
        <div>
          <span className="flex items-center gap-2.5">
            <BrandMark size={20} reversed />
            <span className="font-display text-xl font-bold text-neutral-50">RallyShift</span>
          </span>
          <p className="mt-3 max-w-[36ch] leading-relaxed">{t('footer.description')}</p>
          <p className="mt-3 text-xs text-neutral-500">{t('footer.predecessor')}</p>
          <p className="mt-6 text-neutral-200">{t('footer.getTheApp')}</p>
          <StoreBadges className="mt-3" />
        </div>

        <div className="flex flex-col gap-2.5">
          <b className="text-neutral-200">{t('footer.product')}</b>
          <a href={section('functies')} className="hover:text-neutral-200">
            {t('navigation.features')}
          </a>
          <a href={section('prijzen')} className="hover:text-neutral-200">
            {t('navigation.pricing')}
          </a>
          <a href={PORTAL_URL} className="hover:text-neutral-200">
            {t('navigation.login')}
          </a>
        </div>

        <div className="flex flex-col gap-2.5">
          <b className="text-neutral-200">{t('footer.support')}</b>
          <Link to="/contact" className="hover:text-neutral-200">
            {t('footer.contactUs')}
          </Link>
          <a href="mailto:support@rallyshift.io" className="hover:text-neutral-200">
            {t('footer.helpCenter')}
          </a>
        </div>

        <div className="flex flex-col gap-2.5">
          <b className="text-neutral-200">{t('footer.legal')}</b>
          <Link to="/privacy-policy" className="hover:text-neutral-200">
            {t('footer.privacyPolicy')}
          </Link>
          <Link to="/terms-of-service" className="hover:text-neutral-200">
            {t('footer.termsOfService')}
          </Link>
          <Link to="/cookie-policy" className="hover:text-neutral-200">
            {t('footer.cookiePolicy')}
          </Link>
        </div>
      </div>

      <div className="mx-auto mt-9 max-w-[1280px] border-t border-neutral-800 pt-5 text-xs text-neutral-500">
        {t('footer.copyright')}
      </div>
    </footer>
  )
}

export default Footer
